export default __webpack_public_path__ + "static/media/Red.7c58f2e3.png";